var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M3.5 14.229V8.77A5.01 5.01 0 0 0 6.771 5.5H17.23A5.01 5.01 0 0 0 20.5 8.771v5.458a5.01 5.01 0 0 0-3.271 3.271H6.77A5.01 5.01 0 0 0 3.5 14.229m0 3.271h1.664A3.52 3.52 0 0 0 3.5 15.836zM2 15V5a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm18.5-7.836A3.52 3.52 0 0 1 18.837 5.5H20.5zM18.837 17.5H20.5v-1.664a3.52 3.52 0 0 0-1.663 1.664M5.164 5.5A3.52 3.52 0 0 1 3.5 7.164V5.5zm5.954 9.077 4.42-4.555-1.076-1.044-3.344 3.445-1.58-1.627-1.076 1.045z",
    clipRule: "evenodd"
  })));
};
export default SvgMoney;